// API Configuration utility
// This file provides environment-based API URL configuration

export const getApiBaseUrl = (): string => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    // Use localhost in development
    return process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
  }
  
  // Use production URL in production
  return process.env.REACT_APP_API_URL || 'https://buddy.con-mot-sach.com/api';
};

// Export the API base URL
export const API_BASE_URL = getApiBaseUrl();

// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = '671449825925-nljvi0q020aekva4c4q5mltiea29p6ro.apps.googleusercontent.com';

// Optional: Helper function to log the current API URL (useful for debugging)
export const logApiConfig = (): void => {
  console.log(`🌐 API Base URL: ${API_BASE_URL}`);
  console.log(`🔧 Environment: ${process.env.NODE_ENV}`);
};
